import { BunnyVideo, type BunnyVideoProps } from "@client/controls/Video/component";
import { connectCustom } from "@client/lib/misc";
import { siteColorSelector } from "@client/selectors";
import { type BaseAppState } from "@client/types";

export const BunnyVideoContainer = connectCustom(
  (state: BaseAppState, props: BunnyVideoProps): BunnyVideoProps => ({
    ...props,
    color: siteColorSelector(state)
  })
)(BunnyVideo);
